import filterFactory, {Comparator, dateFilter, numberFilter, textFilter} from "react-bootstrap-table2-filter";
import Moment from "moment/moment";
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {ColumnToggle} from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';


const {ToggleList} = ColumnToggle;
export const Logs = ({logs, filter, setFilter}) => {
    const columns = [{
        dataField: 'index',
        text: 'Index',
        sort: true
    }, {
        dataField: 'uid',
        text: 'Uid',
        filter: textFilter({
            defaultValue: filter instanceof Map && filter.has("uid") ? filter.get("uid") : '',
            onFilter: (filterValue) => {
                setFilter("uid", filterValue)
            }
        }),
        sort: true
    }, {
        dataField: 'status',
        text: 'Status',
        filter: textFilter({
            defaultValue: filter instanceof Map && filter.has("status") ? filter.get("status") : '',
            onFilter: (filterValue) => {
                setFilter("status", filterValue)
            }
        }),
        sort: true
    }, {
        dataField: 'log',
        text: 'Log',
        filter: textFilter({
            defaultValue: filter instanceof Map && filter.has("log") ? filter.get("log") : '',
            onFilter: (filterValue) => {
                setFilter("log", filterValue)
            }
        }),
        sort: true,
        formatter: logFormatter
    }, {
        dataField: 'companyUid',
        text: 'Company ID',
        filter: textFilter({
            defaultValue: filter instanceof Map && filter.has("companyUid") ? filter.get("companyUid") : '',
            onFilter: (filterValue) => {
                setFilter("companyUid", filterValue)
            }
        }),
        sort: true,
        hidden: true
    }, {
        dataField: 'time',
        text: 'Date',
        filter: dateFilter({
            defaultValue: filter instanceof Map && filter.has("time") ? filter.get("time") : {},
            onFilter: (filterValue) => {
                setFilter("time", filterValue)
            }
        }),
        formatter: dateFormatter,
        csvFormatter: dateFormatter,
        sort: true
    }];

    function logFormatter(cell, row) {
        if(cell.length > 200) {
            return cell.substring(0, 200) + '...';
        } else {
            return cell;
        }
    }

    function dateFormatter(cell, row) {
        return Moment.tz(cell, 'Europe/Belgrade').format('DD.MM.YYYY HH:mm:ss');
    }

    const options = {
        sizePerPageList: [{text: '50', value: 50}, {text: '100', value: 100}, {text: '250', value: 250}, {
            text: 'All',
            value: logs.length
        }],
        showTotal: true
    }

    return (
        <ToolkitProvider
            keyField='index'
            data={logs}
            columns={columns}
            columnToggle
            pagination={paginationFactory(options)}
            exportCSV={{
                exportAll: false,
                onlyExportFiltered: true
            }}>
            {props => (
                <div>
                    <hr/>
                    <ToggleList {...props.columnToggleProps} />
                    <hr/>
                    <BootstrapTable striped bordered hover {...props.baseProps}
                                    pagination={paginationFactory(options)}
                                    bootstrap4={true}
                                    tabIndexCell
                                    filter={filterFactory()}
                    />
                </div>
            )
            }
        </ToolkitProvider>
    )
}